module.exports = __webpack_public_path__ + "img/appLandingLogo.f1f97bdd.jpg";